<script setup>
import TakeControl from '@/components/section/TakeControl.vue';
import BeAware from '@/components/section/BeAware.vue';
import ContentMatters from '@/components/section/ContentMatters.vue';
import HowDidWeDoThat from '@/components/section/HowDidWeDoThat.vue';
import LetsThinkAbout from '@/components/section/LetsThinkAbout.vue';
import ThingsToConsider from '@/components/section/ThingsToConsider.vue';
</script>

<template>
  <main>
    <TakeControl />
    <BeAware />
    <LetsThinkAbout />
    <ContentMatters />
    <ThingsToConsider />
    <HowDidWeDoThat />
  </main>
</template>
